import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Dialog } from '@gem/ui-kit';

import { ICommonPopupsProps } from '../PopupManager/PopupManager.types';
import {
  IConfirmPopupPresenterParams,
  IConfirmPopupResult,
  useConfirmPopupPresenter,
} from './ConfirmPopup.presenter';

export interface IConfirmPopupParams extends IConfirmPopupPresenterParams {
  text?: string;
  html?: string;
  title?: string;
  primaryText?: string;
  secondaryText?: string | null;
  checkBoxText?: string;
  isChecked?: boolean;
  hasCloseButton?: boolean;
  popupClassName?: string;
}
export const ConfirmPopup: FC<ICommonPopupsProps<IConfirmPopupParams, IConfirmPopupResult>> =
  observer((props) => {
    const { t } = useTranslation();
    const { popupInstance, params, onClose: onResult } = props;
    const {
      text,
      html,
      title,
      primaryText,
      secondaryText,
      checkBoxText,
      hasCloseButton,
      popupClassName,
      ...presenterParams
    } = params!;
    const { isLoading, isChecked, onCheckBoxChange, onSuccess, onCancel, onClose } =
      useConfirmPopupPresenter(presenterParams, popupInstance, onResult);

    return (
      <Dialog
        isOpened
        onClose={onClose}
        title={title}
        text={text}
        html={html}
        primaryText={primaryText || t('common_yes')}
        primaryOnClick={onSuccess}
        isSelected={isChecked}
        isLoading={isLoading}
        checkBoxText={checkBoxText}
        checkBoxChange={onCheckBoxChange}
        secondaryText={secondaryText === null ? undefined : secondaryText || t('common_cancel')}
        secondaryOnClick={onCancel}
        hasCloseButton={hasCloseButton}
        popupClassName={popupClassName}
      />
    );
  });
